import { render } from "./MSecondaryButton.vue?vue&type=template&id=9dfeab7e"
import script from "./MSecondaryButton.vue?vue&type=script&lang=js"
export * from "./MSecondaryButton.vue?vue&type=script&lang=js"

import "./MSecondaryButton.vue?vue&type=style&index=0&id=9dfeab7e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__